import { gql } from '@apollo/client'

// Product Mutations
export const CREATE_PRODUCT = gql`
  mutation CreateProduct($productData: CreateProductData!) {
    createProduct(productData: $productData) {
      id
      name
      kind
      active
      display_in_pos
      display_in_webshop
      platforms {
        platform { slug displayName sortOrder active }
        enabled
      }
      allergen_info_json { allergens custom_warnings }
      attributes_json { attributes spice_level }
      created_at
    }
  }
`

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($id: Int!, $productData: UpdateProductData!) {
    updateProduct(id: $id, productData: $productData) {
      id
      name
      kind
      active
      display_in_pos
      display_in_webshop
      platforms {
        platform { slug displayName sortOrder active }
        enabled
      }
      allergen_info_json { allergens custom_warnings }
      attributes_json { attributes spice_level }
      updated_at
    }
  }
`

// Availability page: one batch per Publish. Own changes always commit; platform
// changes only when HubRise accepted them (platform_sync). The returned products
// update the normalized Product entries, so the register grid follows by itself.
export const PUBLISH_PRODUCT_AVAILABILITY = gql`
  mutation PublishProductAvailability($changes: [ProductAvailabilityChange!]!) {
    publishProductAvailability(changes: $changes) {
      products {
        id
        sold_out
        sold_out_until
        platforms_sold_out
        platforms_sold_out_until
      }
      platform_sync {
        status
        message
        not_on_platforms
      }
    }
  }
`

export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($id: Int!) {
    deleteProduct(id: $id)
  }
`

export const ACTIVATE_PRODUCT = gql`
  mutation ActivateProduct($id: Int!) {
    activateProduct(id: $id) {
      id
      active
    }
  }
`

export const DEACTIVATE_PRODUCT = gql`
  mutation DeactivateProduct($id: Int!) {
    deactivateProduct(id: $id) {
      id
      active
    }
  }
`

// Product Variant Mutations
export const CREATE_PRODUCT_VARIANT = gql`
  mutation CreateProductVariant($variantData: CreateProductVariantData!) {
    createProductVariant(variantData: $variantData) {
      id
      name
      price_cents
      deposit_cents
      sku
      size
      product_id
    }
  }
`

export const UPDATE_PRODUCT_VARIANT = gql`
  mutation UpdateProductVariant($id: Int!, $variantData: UpdateProductVariantData!) {
    updateProductVariant(id: $id, variantData: $variantData) {
      id
      name
      price_cents
      deposit_cents
      sku
      size
    }
  }
`

export const DELETE_PRODUCT_VARIANT = gql`
  mutation DeleteProductVariant($id: Int!) {
    deleteProductVariant(id: $id)
  }
`

export const ACTIVATE_PRODUCT_VARIANT = gql`
  mutation ActivateProductVariant($id: Int!) {
    activateProductVariant(id: $id) {
      id
      active
    }
  }
`

export const DEACTIVATE_PRODUCT_VARIANT = gql`
  mutation DeactivateProductVariant($id: Int!) {
    deactivateProductVariant(id: $id) {
      id
      active
    }
  }
`

// Category Mutations
export const CREATE_CATEGORY = gql`
  mutation CreateCategory($categoryData: CreateCategoryData!) {
    createCategory(categoryData: $categoryData) {
      id
      name
      display_in_pos
      display_in_webshop
      platforms {
        platform { slug displayName sortOrder active }
        enabled
      }
      parent_id
    }
  }
`

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory($id: Int!, $categoryData: UpdateCategoryData!) {
    updateCategory(id: $id, categoryData: $categoryData) {
      id
      name
      display_in_pos
      display_in_webshop
      platforms {
        platform { slug displayName sortOrder active }
        enabled
      }
      parent_id
    }
  }
`

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($id: Int!) {
    deleteCategory(id: $id)
  }
`

export const ACTIVATE_CATEGORY = gql`
  mutation ActivateCategory($id: Int!) {
    activateCategory(id: $id) {
      id
      active
    }
  }
`

export const DEACTIVATE_CATEGORY = gql`
  mutation DeactivateCategory($id: Int!) {
    deactivateCategory(id: $id) {
      id
      active
    }
  }
`

// Product ↔ Category Assignment
export const ASSIGN_CATEGORY_TO_PRODUCT = gql`
  mutation AssignCategoryToProduct($productId: Int!, $categoryId: Int!) {
    assignCategoryToProduct(productId: $productId, categoryId: $categoryId)
  }
`

export const REMOVE_CATEGORY_FROM_PRODUCT = gql`
  mutation RemoveCategoryFromProduct($productId: Int!, $categoryId: Int!) {
    removeCategoryFromProduct(productId: $productId, categoryId: $categoryId)
  }
`

// Bundle Mutations
export const CREATE_BUNDLE_GROUP = gql`
  mutation CreateBundleGroup($bundleGroupData: CreateBundleGroupData!) {
    createBundleGroup(bundleGroupData: $bundleGroupData) {
      id
      name
      required_count
      bundle_product_id
    }
  }
`

export const UPDATE_BUNDLE_GROUP = gql`
  mutation UpdateBundleGroup($id: Int!, $bundleGroupData: UpdateBundleGroupData!) {
    updateBundleGroup(id: $id, bundleGroupData: $bundleGroupData) {
      id
      name
      required_count
    }
  }
`

export const DELETE_BUNDLE_GROUP = gql`
  mutation DeleteBundleGroup($id: Int!) {
    deleteBundleGroup(id: $id)
  }
`

// Bundle Option Mutations
export const CREATE_BUNDLE_OPTION = gql`
  mutation CreateBundleOption($bundleOptionData: CreateBundleOptionData!) {
    createBundleOption(bundleOptionData: $bundleOptionData) {
      id
      price_delta_cents
      bundle_group_id
      eligible_variant {
        id
        name
        price_cents
        deposit_cents
      }
    }
  }
`

export const UPDATE_BUNDLE_OPTION = gql`
  mutation UpdateBundleOption($id: Int!, $bundleOptionData: UpdateBundleOptionData!) {
    updateBundleOption(id: $id, bundleOptionData: $bundleOptionData) {
      id
      price_delta_cents
      eligible_variant {
        id
        name
        price_cents
        deposit_cents
      }
    }
  }
`

export const DELETE_BUNDLE_OPTION = gql`
  mutation DeleteBundleOption($id: Int!) {
    deleteBundleOption(id: $id)
  }
`
